export default __webpack_public_path__ + "static/media/flag-ghana.7c5c1454.svg";